import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotEye = ({
    spotColor = "#FCB5A9",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <path
            fill={spotColor}
            d="M19.964 17.097c3.372 2.678 7.728 4.856 12.65 4.57 12.856-.714 5.25-16.191-.808-19.57-3.95-2.2-9.449-2.913-14.027-.95a9.813 9.813 0 0 0-2.307 1.43c-1.821.2-3.657 1.485-3.457 3.463.443 4.321 4.4 8.235 7.95 11.057Z"
            opacity={0.75}
        />
        <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={strokeWidth}
            d="M1.668 20S8.335 6.667 20.001 6.667C31.668 6.667 38.335 20 38.335 20S31.668 33.334 20 33.334C8.335 33.334 1.668 20 1.668 20Z"
        />
        <path
            stroke="#13126C"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={strokeWidth}
            d="M20 25a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"
        />
    </SVG>
);
SpotEye.displayName = "SpotEye";
